import { cpfValidator } from './cpfValidator'
import { emailValidator } from './emailValidator'
import { cnpjValidator } from './cnpjValidator'
import { telefoneValidator } from './telefoneValidator'

export const pixValidator = function (key) { 
  if(!key) return false
  const pix = key.trim() 
  return cpfValidator(pix) || cnpjValidator(pix) || emailValidator(pix) || telefoneValidator(pix)
  
}
